import styled from 'styled-components';

export const Title = styled.h2`
    font-size: 2.5rem;
    color: #49688d;
    text-align: center;
    padding-bottom: 20px;
    margin: 0;
`;
